// import React, { useEffect, useState } from 'react';
// import { Button, NewTable } from '../../../../components';
// import { allBillsrowdata } from '../../../../assets/data/candidatesData';
// import { mapTableRows } from '../../../../utils';
// import Checkbox from '../../../../components/FormFields/Checkbox';

// const DraftBills = () => {
//   const tablerowData = allBillsrowdata;

//   const DraftColumns = [

//     {
//       key: "InvoiceNumber",
//       label: "Invoice Number",
//       render: (row) => (
//         <span
//           className="cursor-pointer text-linkblue"
//           onClick={() => console.log(row)}
//         >{row.InvoiceNumber}
//         </span>
//       ),
//     },
//     { key: "Employees", label: "Employees" },
//     { key: "Vendor", label: "Vendor" },
//     { key: "VendorID", label: "Vendor ID" },
//     { key: "InvoiceDate", label: "Invoice Date" },
//     { key: "InvoiceDueDate", label: "Invoice Due Date" },
//     { key: "BillAmount", label: "Bill Amount" },
//     { key: "PaidAmount", label: "Paid Amount" },
//     { key: "DiscountAmount", label: "Discount Amount" },
//     { key: "DueAmount", label: "Due Amount" },
//     { key: "CreatedOn", label: "Created On" },
//        {
//       key: "actions",
//       label: "Actions",
//       render: (row) => (
//         <div className="flex items-center gap-2">
//           <Button
//             type="icon"
//             icon="download"
//             size="xs"
//             variant="text"
//             color="black"
//             onClick={""}
//           />
//           <Button
//             type="icon"
//             icon="edit_square"
//             size="xs"
//             variant="text"
//             color="black"
//             onClick={""}
//           />
//           <Button
//             type="icon"
//             icon="delete"
//             size="xs"
//             variant="text"
//             color="black"
//             onClick={""}

//           />
//         </div>
//       ),
//     },
//   ];

//   const mappedRows = mapTableRows(tablerowData, DraftColumns);

//   return (
//     <div>
//       <NewTable

//         columns={DraftColumns}
//         rows={mappedRows}
//         toolbarRight={[
//           { filterButton: false },
//           { DropdownMenu: false },
//         ]}
//       />
//     </div>
//   );
// };

// export default DraftBills;

import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  LogoLoader,
  Modal,
  TableAdv,
  StatusTags,
  SmartTooltip,
} from "../../../../components";
import { dateFormator, mapTableRows } from "../../../../utils";
import { useSelector, useDispatch } from "react-redux";
import { getAccountPayablesStart } from "../../../../redux/slices/accountPayables/accountPayablesSlice";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import { usePagination } from "../../../../hooks";
import { Link, useNavigate } from "react-router-dom";
import { getVendorId } from "../../../../utils/getClientId";
import { formatCurrency } from "../../../../utils/stringUtils";
import ApInvoiceDetails from "../Modals/ApInvoiceDetails";

const DraftBills = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [sortConfig, setSortConfig] = useState({
    field: "uiid",
    direction: -1,
  });

  const { loading, error, accountPayables } = useSelector(
    (state) => state.accountPayables,
  );

  const { value } = useSelector((state) => state.totalCount);
  const totalCount = value?.accountpayables?.data;

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {
      dispatch(getAccountPayablesStart({ page: newPage, limit: newLimit }));
    },
  );

  const tablerowData = accountPayables?.data || [];

  const handleSort = (field) => {
    setSortConfig((prevSort) => ({
      field,
      direction: prevSort.field === field ? -prevSort.direction : -1,
    }));
  };

  const DraftColumns = [
    {
      key: "invoiceNum",
      label: "Invoice Number",
      render: (row) => (
        <SmartTooltip
          description={row.invoiceNum}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <span
            className="cursor-pointer text-linkblue line-clamp-1!"
            onClick={() => setSelectedInvoice(row?.uiid)}
          >
            {row.invoiceNum}
          </span>
        </SmartTooltip>
      ),
    },
    {
      key: "employeeId",
      label: "Employees",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => {
        const employees = row?.employeeId || [];

        const names = employees
          .map((item) =>
            [item?.firstName, item?.lastName].filter(Boolean).join(" "),
          )
          .filter(Boolean);

        return (
          <SmartTooltip
            description={names.join(", ")}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
          >
            <div className="line-clamp-1!">
              {names.length > 0 ? names.join(", ") : "-"}
            </div>
          </SmartTooltip>
        );
      },
    },
    {
      key: "vendorId",
      label: "Vendor",
      width: "min-w-[150px]! max-w-[200px]!",
      render: (row) => {
        return (
          <SmartTooltip
            description={row.vendorId.businessName}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
          >
            <div>{row.vendorId.businessName || "-"}</div>
          </SmartTooltip>
        );
      },
    },
    {
      key: "VendorID",
      label: "Vendor ID",
      width: "min-w-[150px]! max-w-[200px]!",
      render: (row) => {
        return (
          <SmartTooltip
            description={getVendorId(row.vendorId.uiid)}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
          >
            <div className="line-clamp-1!">
              {getVendorId(row.vendorId.uiid)}
            </div>
          </SmartTooltip>
        );
      },
    },
    {
      key: "invoiceDate",
      label: "Invoice Date",
      render: (row) => dateFormator(row.invoiceDate, "month-day-year"),
    },
    {
      key: "dueDate",
      label: "Invoice Due Date",
      render: (row) => dateFormator(row.dueDate, "month-day-year"),
    },
    {
      key: "billedAmount",
      label: "Bill Amount",
      render: (row) => formatCurrency(row.amounts.billed),
    },
    {
      key: "paidAmount",
      label: "Paid Amount",
      render: (row) => formatCurrency(row.amounts.paid),
    },
    {
      key: "discountAmount",
      label: "Discount Amount",
      render: (row) => formatCurrency(row.amounts.discount),
    },
    {
      key: "dueAmount",
      label: "Due Amount",
      render: (row) => formatCurrency(row.amounts.due),
    },
    {
      key: "addedOn",
      label: "Created On",
      render: (row) => dateFormator(row.addedOn, "month-day-year"),
    },
    {
      key: "Actions",
      label: "Actions",
      render: (row) => (
        <div className="flex items-center gap-2">
          <Button
            type="icon"
            icon="download"
            size="xs"
            variant="text"
            color="black"
            onClick={""}
          />
          <Button
            type="icon"
            icon="edit_square"
            size="xs"
            variant="text"
            color="black"
            onClick={() => navigate(`/accounts-payable/edit/${row.uiid}`)}
          />
          <Button
            type="icon"
            icon="delete"
            size="xs"
            variant="text"
            color="black"
            onClick={""}
          />
        </div>
      ),
    },
  ];

  const mappedRows = mapTableRows(tablerowData, DraftColumns);

  useEffect(() => {
    dispatch(
      getAccountPayablesStart({
        limit,
        page,
        filters: {
          status: {
            type: "NONE",
            value: 1,
          },
        },
        ref: "Employee Vendor",
        incl: ["firstName lastName", "businessName"],
        sort: { [sortConfig.field]: sortConfig.direction },
      }),
    );
    dispatch(
      totalCountStart({
        filters: {
          status: {
            type: "NONE",
            value: 1,
          },
        },
        collection: "accountpayables",
        coll: "AccountPayable",
      }),
    );
  }, [dispatch, page, limit, sortConfig]);

  return (
    <div className="flex flex-1 flex-col overflow-hidden">
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
      <TableAdv
        tableId={"accountpayable_draftbilltable"}
        showCheckbox
        columns={DraftColumns}
        rows={mappedRows}
        defaultSelectedRows={selectedRows}
        onSelectionChange={setSelectedRows}
        toolbarRight={{ search: true }}
        serverPagination={true}
        totalCount={totalCount}
        page={page}
        limit={limit}
        onPageChange={setPage}
        onLimitChange={handleLimitChange}
      />
      <Modal
        isOpen={selectedInvoice}
        title={"AP Invoice Details"}
        onClose={() => setSelectedInvoice(null)}
        showCloseButton={true}
        closeOnOutsideClick={true}
        width="max-w-full"
        zIndex={56}
      >
        <ApInvoiceDetails
          invoiceUiid={selectedInvoice}
          onBack={() => setSelectedInvoice(null)}
          removeButtonForPreview={false}
        />
      </Modal>
    </div>
  );
};

export default DraftBills;
